import { createAction, props } from '@ngrx/store';
import { SourceData } from '@app/Shared/interfaces/iSources';

// Load Sources Actions
export const loadSources = createAction('[SOURCES] LOAD_SOURCES');
export const loadSourcesSuccess = createAction('[SOURCES] LOAD_SOURCES_SUCCESS', props<{ sources: SourceData[] }>());
export const loadSourcesFailure = createAction('[SOURCES] LOAD_SOURCES_FAILURE', props<{ error: string }>());

// Create Source Actions
export const createSource = createAction('[SOURCES] CREATE_SOURCE', props<{ sourceData: SourceData }>());
export const createSourceSuccess = createAction('[SOURCES] CREATE_SOURCE_SUCCESS', props<{ source: SourceData }>());
export const createSourceFailure = createAction('[SOURCES] CREATE_SOURCE_FAILURE', props<{ error: string }>());

// Update Source Actions
export const updateSource = createAction('[SOURCES] UPDATE_SOURCE', props<{ key: number; sourceData: SourceData }>());
export const updateSourceSuccess = createAction('[SOURCES] UPDATE_SOURCE_SUCCESS', props<{ source: SourceData }>());
export const updateSourceFailure = createAction('[SOURCES] UPDATE_SOURCE_FAILURE', props<{ error: string }>());

// Delete Source Actions
export const deleteSource = createAction('[SOURCES] DELETE_SOURCE', props<{ key: number }>());
export const deleteSourceSuccess = createAction('[SOURCES] DELETE_SOURCE_SUCCESS', props<{ key: number }>());
export const deleteSourceFailure = createAction('[SOURCES] DELETE_SOURCE_FAILURE', props<{ error: string }>());

// Select Source Actions
export const selectSource = createAction('[SOURCES] SELECT_SOURCE', props<{ source: SourceData | null }>());
export const clearSelectedSource = createAction('[SOURCES] CLEAR_SELECTED_SOURCE');
